import { Stack, Tooltip, Typography } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import React from "react";
import { globalTheme } from "../../styles";
import { IS_BUNDLE_VIEW } from "../../constants";

type CustomCellRendererPropsWithBundleView = CustomCellRendererProps;

// Memoise cell level component to avoid unnecessary re-renders. This helps enhancing performance improvements
export const ItemCell = React.memo((params: CustomCellRendererPropsWithBundleView) => {
  const { data } = params;

  // Check if data.items exists and is an array
  if (!data.items || !Array.isArray(data.items)) {
    return null; // Or handle this case as needed
  }
  const { items } = data;

  const isBundleView = JSON.parse(localStorage.getItem(IS_BUNDLE_VIEW)) || false;
  return (
    <Stack>
      {items.map((item, key) => {
        // Determine the data source based on bundleView and item.isBundle
        const dataSource = !isBundleView && item.isBundle ? item.bundleComponents : [item];
        return (
          <Stack direction="column" key={key} spacing={1}>
            {dataSource.map((info, idx) => (
              <Stack direction="row" spacing={2} alignItems="center" key={idx} margin={0.5}>
                <a href={info?.imageURL} target="_blank" rel="noopener noreferrer">
                  <img src={`${info.imageURL}`} width={"75px"} height="75px" alt="product" />
                </a>
                <Stack>
                  <Typography variant="subtitle1">{info.title}</Typography>
                  <Typography variant="caption" color={globalTheme.primaryColor}>
                    {info.varyingAttributes}
                  </Typography>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="caption">Quantity:</Typography>
                    <Tooltip title={`Quantity Left in Stock: ${info.availableQty || "N/A"}`}>
                      <Typography
                        variant="h6"
                        color={globalTheme.orange}
                        fontWeight="bold"
                        sx={{ cursor: "pointer" }} // Adds a pointer cursor for better UX
                      >
                        {info.quantity}
                      </Typography>
                    </Tooltip>
                    <Typography variant="caption">SKU:</Typography>
                    <Typography
                      variant="caption"
                      component="a" // Render as an anchor tag
                      href={info.productURL} // Set the URL
                      color={globalTheme.primaryColor}
                      target="_blank" // Opens link in a new tab
                      rel="noopener noreferrer" // Security best practices for external links
                    >
                      {info.sku}
                    </Typography>
                    <Typography variant="caption">Location:</Typography>
                    <Tooltip title={`Excess Location: ${info.excessStock || "N/A"}`}>
                      <Typography
                        variant="caption"
                        color={globalTheme.primaryColor}
                        sx={{ cursor: "pointer" }} // Adds a pointer cursor for better UX
                      >
                        {info.warehouseLocation}
                      </Typography>
                    </Tooltip>
                  </Stack>
                </Stack>
              </Stack>
            ))}
          </Stack>
        );
      })}
    </Stack>
  );
});
